import React from 'react';
import PublicTwoToneIcon from '@mui/icons-material/PublicTwoTone';
import LockOpenTwoTone from '@mui/icons-material/LockOpenTwoTone';
import CloudTwoToneIcon from '@mui/icons-material/CloudTwoTone';
import InsertDriveFileTwoToneIcon from '@mui/icons-material/InsertDriveFileTwoTone';
import { Typography, Box } from '@mui/material';
import { LayerTypes, OriginTypes } from '../models/layer-settings';

interface Props {
  layerType: LayerTypes;
  origin: OriginTypes;
  fileSize: undefined|number;
  username: undefined|string;
  opacity: undefined|number;
}

const iconStyling = {
  width: '0.75em',
  height: '0.75em',
  fontSize: '1rem',
  top: '2px',
  position: 'relative',
};

const renderLayerIcon = (type: LayerTypes, origin: OriginTypes, opacity: number) => {
  switch (type) {
    case 'xyz':
    case 'geojson':
    case 'wms':
      return <CloudTwoToneIcon sx={iconStyling} color="info" opacity={opacity} />;
    case 'fulcrum':
    case 'kml':
    case 'mbtiles':
      return <InsertDriveFileTwoToneIcon sx={iconStyling} color="info" opacity={opacity} />;
    case 'feature-service':
      return origin === 'fulcrum' ? <PublicTwoToneIcon sx={iconStyling} color="info" /> : <LockOpenTwoTone sx={iconStyling} color="info" />;
    default:
      return <></>;
  }
};

const humanReadableFileSize = (fileSize: undefined|number): string => {
  if (!fileSize) {
    return '0 B';
  }

  const units = ['B', 'KB', 'MB', 'GB'];
  let i = 0;
  let size = fileSize;
  while (size >= 1024 && i < 3) {
    size /= 1024;
    i += 1;
  }
  return `${size.toFixed(1)} ${units[i]}`;
};

export const layerTypeSubtitle = (
  type: LayerTypes,
  origin: OriginTypes,
  fileSize: undefined|number,
  username: undefined|string,
) => {
  switch (type) {
    case 'mbtiles':
      return `MBTiles - ${humanReadableFileSize(fileSize)}`;
    case 'xyz':
      return 'Tile XYZ';
    case 'kml':
      return `KML/KMZ - ${humanReadableFileSize(fileSize)}`;
    case 'geojson':
      return 'GeoJSON';
    case 'wms':
      return 'WMS';
    case 'fulcrum':
      return 'Fulcrum App';
    case 'feature-service':
      return origin === 'fulcrum'
        ? 'ArcGIS Feature Service'
        : `ArcGIS Feature Service (${username})`;
    default:
      return '';
  }
};

const LayerPickerLayerType: React.FC<Props> = ({
  layerType, origin, fileSize, username, opacity,
}) => (
  <Box>
    {renderLayerIcon(layerType, origin, opacity ?? 1)}
    <Typography
      sx={{
        fontWeight: 400,
        fontSize: '10px',
        color: 'rgba(0, 0, 0, 0.6)',
        display: 'inline',
        paddingLeft: '5px',
        opacity: opacity ?? 1,
      }}
    >
      {layerTypeSubtitle(layerType, origin, fileSize, username)}
    </Typography>
  </Box>
);

export default LayerPickerLayerType;
